import { render, staticRenderFns } from "./Ipaccesslists.vue?vue&type=template&id=04d866e6&"
import script from "./Ipaccesslists.vue?vue&type=script&lang=js&"
export * from "./Ipaccesslists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports